/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Password Recovery View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './passwordRecoveryView';

export const mapStateToPropsPassRecovery = mapStateToProps;
export const mapDispatchToPropsPassRecovery = mapDispatchToProps;

export default connect(
  mapStateToPropsPassRecovery,
  mapDispatchToPropsPassRecovery
)(View);
